export default __webpack_public_path__ + "images/d4c3a83a2dc44190567b969ba8916ac4-menu-dog-outside.svg";